import React from 'react';

import Links from '~/components/Workflow/shared/Links';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

function ConfirmDelete({ condition }) {
  const intl = useIntl();

  if (!condition) {
    return null;
  }

  const { length } = condition.links;

  return (
    <FlexLayout flexDirection="column" space={6}>
      {length > 0 && (
        <FlexLayout
          bg="red-600"
          color="white"
          flexDirection="column"
          p={6}
          space={2}
        >
          <Text variant="m-dense-bold">
            {intl.formatMessage(
              {
                id: 'ConfirmDelete.linkedObjectsWarning',
                defaultMessage:
                  'This condition is linked to {count, plural, one {# object} other {# objects}}',
                description: 'Warning message for linked objects count',
              },
              { count: length },
            )}
          </Text>
          <Text variant="s-spaced">
            {intl.formatMessage({
              id: 'ConfirmDelete.deleteConsequences',
              defaultMessage:
                'Deleting the condition will have consequences for the objects listed below.',
              description: 'Warning about consequences of deleting condition',
            })}
          </Text>
        </FlexLayout>
      )}
      <Links links={condition.links} />
      <Text variant="s-spaced">
        {intl.formatMessage({
          id: 'ConfirmDelete.confirmationMessage',
          defaultMessage: 'Are you sure you want to delete this condition?',
          description: 'Confirmation message for deleting condition',
        })}
      </Text>
    </FlexLayout>
  );
}

export default ConfirmDelete;
